import * as PIXI from 'pixi.js';
import {getNearestTierTexture, Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

export class FrigateArmadilloGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    // Center
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 1,
      x: 2,
      y: 43,
      scale: 1.8,
    }));

    const shipTexture = getNearestTierTexture(ship.getHighestModuleTier(), 'ships', 'frigate_armadillo_t%.png')
    if (shipTexture) {
      const sprite = new PIXI.Sprite(shipTexture);
      this.addChild(sprite);
    }
  }

  getSize(): number {
    return HullSize.Normal;
  }
}
